import { IconBrandX } from '@tabler/icons-react';
import { Link } from 'react-router';

import { DiscordIcon, GithubIcon } from '@/components/svgs/icons';

export const FooterBrandIcons = () => {
  return (
    <div className="flex items-center gap-6">
      <Link
        target="_blank"
        to="https://github.com/flagsync"
        className="text-muted-foreground hover:text-muted-foreground/75"
      >
        <GithubIcon className="size-6 fill-muted-foreground hover:fill-muted-foreground/75" />
      </Link>
      <Link
        target="_blank"
        to="https://discord.gg/4ggZrzzUJs"
        className="text-muted-foreground hover:text-muted-foreground/75"
      >
        <DiscordIcon className="size-6 fill-muted-foreground hover:fill-muted-foreground/75" />
      </Link>
      <Link
        target="_blank"
        to="https://twitter.com/flagsync"
        className="text-muted-foreground hover:text-muted-foreground/75"
      >
        <IconBrandX className="size-6" />
      </Link>
    </div>
  );
};
